import { createAsyncThunk } from "@reduxjs/toolkit"
import { createPublicReportApi, getPublicReportApi, getPublicShareReportApi, publicCaseReportApi } from "../../apis"
import { ICreatePublicReport } from "../../apis/IApisInterface";
import { showSnackbar } from "../../slices/SnackbarSlice";

export const getPublicShareReportAction = createAsyncThunk("get/public/share/report", async (params: { heatmapId: any; lat: any; lng: any; businessId: any }, { rejectWithValue }) => {
    try {
        const response = await getPublicShareReportApi(params)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get public share report" })
    }
})

export const createPublicReportAction = createAsyncThunk("create/public/report", async (data: ICreatePublicReport, { rejectWithValue, dispatch }) => {
    try {
        const response = await createPublicReportApi(data)
        dispatch(showSnackbar({ message: response?.data?.message || "Email sent to business email address", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error?.response?.data || { message: "Could not create public report" })
    }
})

export const getPublicReportAction = createAsyncThunk("get/public/report", async (id: string, { rejectWithValue }) => {
    try {
        const response = await getPublicReportApi(id)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get public report" })
    }
})

export const publicCaseReportAction = createAsyncThunk("get/public/case", async (params: { id: any, lat: any, long: any }, { rejectWithValue }) => {
    try {
        const response = await publicCaseReportApi(params)
        return response.data
    } catch (error: any) {
        return rejectWithValue(error?.response?.data || { message: "Could not get public case report" })
    }
})